let scriptAdded = false;

export const setExternalReviewScript = (scriptUrl: string): void => {
    if (!scriptAdded) {
        const newScriptElement = document.createElement('script');
        newScriptElement.async = true;
        newScriptElement.src = scriptUrl;
        const targetElement = document.querySelectorAll('script')[0] || document.body;
        targetElement.parentNode?.insertBefore(newScriptElement, targetElement);
        scriptAdded = true;
    }
};
